import { enUS } from './en-US';
import { zhCN } from './zh-CN';
export var language = {
  enUS: enUS,
  zhCN: zhCN
};